/* eslint react/prop-types: 0 */
import React from 'react';
import { camelCase } from 'lodash';
import StakeCell from '../../../shared/cells/StakeCell';
import { formatSalePrice } from '../../../utils/money';
import { JockeyLink, CourseLink, TrainerLink } from '../../../shared/links/ProfileLink';
import { sortByDate, formatDate, sortByRecentMonth } from '../../../utils/date';
import { sortByRaceName } from '../../../utils/name';
import { mapYardGroups } from '../../../utils/distance';
import { selection } from '../../../utils/filter';

export const statsColumns = isIre => [
    {
        key: 'place1stNumber',
        header: 'wins',
    },
    {
        key: 'racesNumber',
        header: 'runs',
    },
    {
        key: 'winPercent',
        header: '%',
    },
    {
        key: 'place2ndNumber',
        header: '2nd',
    },
    {
        key: 'place3rdNumber',
        header: '3rd',
    },
    {
        key: 'place4thNumber',
        header: '4th',
    },
    {
        key: `${isIre ? 'euroT' : 't'}otalPrize`,
        header: 'total earnings',
        cell: ({ totalPrize, euroTotalPrize }) => (isIre
            ? formatSalePrice(euroTotalPrize, 'EUR')
            : formatSalePrice(totalPrize, 'GBP')
        ),
    },
    {
        key: 'stake',
        header: `${isIre ? '€' : '£'}1 stake`,
        cell: StakeCell,
    },
];

const columns = {
    year: {
        header: 'year',
        key: 'seasonEndDate',
        cell: ({ seasonEndDate }) => formatDate(seasonEndDate, 'YYYY'),
        sortFn: sortByDate('seasonEndDate'),
    },
    season: {
        header: 'season',
        key: 'seasonEndDate',
        cell: ({ seasonEndDate, seasonStartDate }) =>
            `${formatDate(seasonStartDate, 'YYYY')}-${formatDate(seasonEndDate, 'YY')}`,
        sortFn: sortByDate('seasonEndDate'),
    },
    course: {
        header: 'course',
        key: 'groupName',
        cell: ({ groupName, groupId }) =>
            (<CourseLink courseStyleName={groupName} courseUid={groupId} />),
        sortFn: 'alphabetic',
    },
    distance: {
        header: 'distance',
        key: 'groupName',
        sortFn: 'alphabetic',
    },
    month: {
        header: 'month',
        key: 'groupName',
        sortFn: sortByRecentMonth('groupName'),
    },
    raceType: {
        header: 'race class',
        key: 'groupName',
        sortFn: sortByRaceName('groupName'),
    },
    raceCategory: {
        header: 'race type',
        key: 'groupName',
        sortFn: 'alphabetic',
    },
    ageOfHorse: {
        header: 'age of horse',
        key: 'groupName',
        sortFn: 'alphabetic',
    },
    jockey: {
        header: 'jockey',
        key: 'groupName',
        cell: ({ groupName, groupId }) =>
            (<JockeyLink jockeyStyleName={groupName} jockeyUid={groupId} />),
        sortFn: 'byLastName',
    },
    trainer: {
        header: 'trainer',
        key: 'groupName',
        cell: ({ groupName, groupId }) =>
            (<TrainerLink trainerStyleName={groupName} trainerUid={groupId} />),
        sortFn: 'byLastName',
    },
};

export const createDynamicColumn = (categories) => {
    const displayBy = camelCase(selection.getValue(categories, 'displayBy'));
    const column = columns[displayBy];

    if (displayBy !== 'month' && displayBy !== 'distance') {
        return column;
    }

    const raceType = selection.getValue(categories, 'raceType').match(/flat|jumps/)[0];

    if (displayBy === 'month') {
        const isFlat = raceType === 'flat';

        const selectedTimePeriod = selection.getValueWithSuffix(categories, 'timePeriod');
        const periodOption = selectedTimePeriod.split('/')[2];
        const isSameYear = periodOption !== 'last5' && periodOption !== 'all';

        return (isSameYear && isFlat) ? {
            ...column,
            cell: ({ groupName }) => groupName.split(' ')[0],
        } : column;
    }

    // distance
    return {
        ...column,
        cell: ({ groupName }) => mapYardGroups(groupName, raceType),
    };
};



// WEBPACK FOOTER //
// ./src/js/human/stats/statsTable/columns.jsx